import { h } from 'preact'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import styled from 'styled-components'


import { PaginationType } from '../reducers'

const Wrapper = styled.div`
  text-align: center;
  .jw-pagination {
     ul {
      display: inline-block;
    }
    li {
      display: inline-block;
      margin-left: 8px;
      margin-right: 8px;
      cursor: pointer;
      a {
        color: #B3BFC4 !important;
        text-decoration: none;
        &:hover {
          text-decoration: none;
        }
      }
      &.jw-pagination-active {
        a {
          color: #1F313A !important;
        }
      }
      &.jw-pagination-break span {
        color: #B3BFC4
      }
    }
 }
`

const Pagination = ({ pagination, onPagination }) => {
  if (pagination.pageCount < 2) {
    return null
  }

  const handlePageClick = (data) => {
    onPagination({ ...pagination, page: data.selected + 1 })
  }

  return (
    <Wrapper>
      <ReactPaginate
        previousLabel={null}
        nextLabel={null}
        breakLabel={<span>...</span>}
        pageCount={pagination.pageCount}
        forcePage={pagination.page - 1}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName="jw-pagination"
        activeClassName="jw-pagination-active"
        breakClassName="jw-pagination-break"
      />
    </Wrapper>
  )
}

Pagination.propTypes = {
  pagination: PaginationType.isRequired,
  onPagination: PropTypes.func.isRequired
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination.js